import { useEffect } from 'react'


const Start = ({ isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            {/* Encabezado */}
            <div className='Screen__Start__Background'>
                {/* {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='Screen__Welcome__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='Screen__Welcome__Background__Image' />
                )} */}
                {/* <img src='/img/page/backgrounds/background-womens-day-2026.png' className='Screen__Welcome__Background__Image' /> */}

                {/* Atributos vitales para fondos: 
                    autoPlay: inicia solo
                    loop: se repite infinitamente
                    muted: OBLIGATORIO para que los navegadores permitan el autoPlay
                    playsInline: previene que en iOS el video se abra a pantalla completa
                */}

                {/* {isActiveWomensMode ? (
                    <img src="/img/page/backgrounds/background-womens-day-2026.png" className="SelfieFan__Screen__Selfie__Background__Image" alt="" />
                ) : isActiveWomensMode === false && (
                    <video 
                    src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                    className='SelfieFan__Screen__QR__Background__Video' 
                    autoPlay loop muted playsInline 
                    />
                )} */}

                <img src="/img/page/backgrounds/background.png" className="SelfieFan__Screen__Selfie__Background__Image" alt="" />
            </div>

            {/* Contenido */}
            <section className="Screen__Start__Container Container-FullHeight">
                {isActiveWomensMode ? (
                    <div className="Screen__Start__Container__Info" style={{ backgroundColor: 'rgba(255,255,255, 0.85)', paddingTop: '60px', paddingLeft: '60px', paddingRight: '60px', width: 'fit-content', margin: '0 auto', borderRadius: '40px' }}>
                        <img src="/img/page/xolos-five-black.png" className="Screen__Start__Container__Logotipo" alt="Logo" />
                        <p className="Screen__Start__Container__Title Text--Gradient--Womens">BIENVENID@S</p>
                    </div>
                ) : isActiveWomensMode === false && (
                    <div className="Screen__Start__Container__Info">
                        <img src="/img/page/xolos-five.png" className="Screen__Start__Container__Logotipo" alt="Logo" />
                        <p className="Screen__Start__Container__Title">BIENVENID@S</p>
                    </div>
                )}
            </section>
            
            {/* Pie de página */}
            <div className='Screen__Start__Footer'>
                {isActiveWomensMode ? (
                    <p className="text-center FooterCredits" style={{ color: '#000000', backgroundColor: 'rgba(255,255,255,0.85)', padding: '0 16px', borderRadius: '16px' }}>Hecho con ♥ por Interaktia | 2026</p>
                ) : isActiveWomensMode === false && (
                    <p className="text-center FooterCredits">Hecho con ♥ por Interaktia | 2026</p>
                )}
            </div>
        </>
    )
}

export { Start };